import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './styles/About.css';

const About = () => {
  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active');
        }
      });
    }, observerOptions);

    const animateElements = document.querySelectorAll('.founder, .principle');
    animateElements.forEach(el => {
      el.classList.add('fade-in');
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About the Artists</h2>
        <h3 className="section-subtitle">"Rejoicing in Rhythms"</h3>
        <h4 className="artists-names">Srujana & Sree Keerthi Valiveti</h4>

        <div className="about-content">
          <p className="about-description">
             A brilliant sister duo, Srujana Valiveti and Sree Keerthi Valiveti have a shared passion for dance, epitomize grace, dedication, and artistic excellence. With an illustrious journey spanning about 18 years, they have honed their skills in Bharatanatyam, an Indian classical dance form, under the tutelage of the esteemed Gurus Dr. Rajeswari Sainath & Dr Vyshnavie Sainath. 
          </p>
          <p className="about-description">
            Their profound love for dance was nurtured by their guru in the pandanallur style of dance, where they imbibed not only the technical nuances of Bharatanatyam but also immeasurable wisdom from world-class exposure to performances and teaching.
          </p>
          <p className="about-description">
            They've performed at prestigious venues like Narada Gana Sabha, Sirifort Delhi,
            and the G20 Summit, and have been featured in major cultural festivals like
            Kalasagaram, Nadaneerajanam, and Doordarshan. Their Arangetram in 2020 marked
            a milestone in their artistic evolution.
          </p>
          <p className="about-description">
            With performances in India and abroad — including Skyline University, Sharjah —
            they bring a global perspective to classical dance education.
            {' '}
            <Link to="/profile" className="read-more-link">Read more...</Link>
          </p>
        </div>

        <div className="founders-info">
          <div className="founder">
            <h4>
              <Link to="/profile#srujana" className="founder-name-link">Srujana Valiveti</Link>
            </h4>
            <p>
              Engineer, MBA graduate, and startup founder (GetYoSpace, IIM Bangalore alum). A certified yoga practitioner trained in Kalaripayattu, she brings analytical precision to artistic expression.
              {' '}
              <Link to="/profile#srujana" className="read-more-link">Read more...</Link>
            </p>
          </div>
          <div className="founder">
            <h4>
              <Link to="/profile#keerthi" className="founder-name-link">Sree Keerthi Valiveti</Link>
            </h4>
            <p>
              Fashion design graduate who brings finesse and pedagogy to the school. Also a certified yoga practitioner trained in Kalaripayattu, she focuses on the aesthetic and technical aspects of dance.
              {' '}
              <Link to="/profile#keerthi" className="read-more-link">Read more...</Link>
            </p>
          </div>
        </div>

        {/* Core Principles */}
        <div className="core-principles">
          <h3>Our Foundation</h3>
          <div className="principles-grid">
            <div className="principle">
              <div className="sanskrit-symbol">भ</div>
              <h4>Bhakti (Devotion)</h4>
              <p>Every movement is an offering, every expression a prayer. We dance to connect with the divine essence that flows through all creation.</p>
            </div>
            <div className="principle">
              <div className="sanskrit-symbol">श</div>
              <h4>Shastra (Precision)</h4>
              <p>Rooted in centuries-old techniques, we honor the sacred geometry of classical form while encouraging personal artistic expression.</p>
            </div>
            <div className="principle">
              <div className="sanskrit-symbol">आ</div>
              <h4>Aananda (Joy)</h4>
              <p>Dance is celebration. In every class, we cultivate joy, community, and the profound satisfaction of artistic growth.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;